<template>
  <div>
    <v-dialog
      v-model="dialogEmail.show"
      :persistent="dialogEmail.persistent"
      max-width="1000"
    >
      <v-card>
        <v-card-title
          class="headline">
          Send an Email: {{dialogEmail.email_template}}
        </v-card-title>
        <v-alert
          v-model="dialogEmail.showResponse"
          :dismissible="true"
          :type="dialogEmail.responseType"
          class="mb-3"
        >
          {{ dialogEmail.responseMessage }}
        </v-alert>
        <v-card-text style="position: relative">
          <div
            v-if="dialogEmail.loading"
            class="email-dialog-overlay">
            <v-layout
              align-center
              justify-center
              row
              fill-height >
              <v-progress-circular
                indeterminate
                color="primary"
              />
              &nbsp;<span class="white--text font-weight-bold">Loading Email Template</span>
            </v-layout>
          </div>
          <v-flex
            xs12
            sm12
            md12>
            <label>Send To: (Press Enter on each email input) </label>
            <!-- <v-text-field
              v-model="dialogEmail.Contact_Email"
              required
              solo
              clearable/> -->
              <v-combobox 
                :disabled="dialogEmail.loading"
                v-model="dialogEmail.emailRecipients"
                ref="receiversRef"
                label="Press Enter on each email input"
                chips
                clearable
                :rules="emailRules"
                multiple
                solo>
                <template v-slot:selection="data">
                    <v-chip :selected="data.selected"
                            close
                            @input="removeEmail(data.item)">
                        <strong>{{ data.item }}</strong>&nbsp;
                    </v-chip>
                </template>
              </v-combobox>
          </v-flex>
          <!-- <v-flex xs12 sm12 md12>
                <label>CC:</label><v-text-field v-model="dialogEmail.cc" required solo clearable></v-text-field>
            </v-flex> -->
          <v-flex
            xs12
            sm12
            md12>
            <label>Subject:</label>
            <v-text-field
              :disabled="dialogEmail.loading"
              v-model="dialogEmail.emailSubjectType"
              required
              solo
              clearable/>
          </v-flex>
          <v-flex
            xs12
            sm12
            md12>
            <label>Template:</label>
            <v-textarea
              :disabled="dialogEmail.loading"
              rows="12"
              v-model="dialogEmail.templateEmail"
              solo/>
          </v-flex>
        </v-card-text>

        <v-card-actions >
          <v-spacer/>

          <v-btn
            :disabled="validateReceiverEmails"
            :loading="dialogEmail.sendHandlerLoading"
            color="orange"
            @click="dialogEmail.sendHandler(dialogEmail.show = false)"
          >
            {{ dialogEmail.sendLabel }}
          </v-btn>
          <v-btn
            :disabled="dialogEmail.yesHandlerLoading"
            color="darken-1"
            @click="dialogEmail.show = false"
          >
            {{ dialogEmail.cancelLabel }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import { debuglog } from 'util'
export default {
  data: () => ({
    Contact_Email: '',
    receiversRef: null,
    changeCounter: 0,
    emailRules :[
      v => {
        if (v.length > 0) {
          for (let i = 0; i < v.length; i++) {
            if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
              // that.hasError = true
              return 'Input must be valid email format';
            }
          }
        }
        return true;
      }
    ]
  }),

  computed: {
    ...mapState('admin/oppregAdmin', ['dialogEmail']),
    validateReceiverEmails() {
      if (this.dialogEmail.loading || this.dialogEmail.emailRecipients.length === 0 || (this.receiversRef && this.receiversRef.errorBucket.length > 0)) {
        return true
      }
      return false
    }
  },
  watch: {
    'dialogEmail.emailSubjectType' (newValue, oldValue) {
      if (this.changeCounter > 1) {
        console.log('emailSubjectType value changed:', newValue)
        this.dialogEmail.isSubjectChanged = true
        this.dialogEmail.newEmailSubjectType = newValue
      }
      this.changeCounter++
    },
    'dialogEmail.templateEmail' (newValue, oldValue) {
      if (this.changeCounter > 1) {
        console.log('templateEmail value changed:', newValue)
        this.dialogEmail.isTemplateChanged = true
        this.dialogEmail.newEmailTemplate = newValue
      }
      this.changeCounter++
    }
  },
  mounted() {
    this.receiversRef = this.$refs.receiversRef;
  },

  methods: {
    removeEmail(email) {
      this.dialogEmail.emailRecipients.splice(this.dialogEmail.emailRecipients.indexOf(email), 1)
    }
  }
}
</script>
<style lang="scss" scoped>

.email-dialog-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 5;
  }
  
</style>
